var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationIcon = function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#location-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16a3 3 0 0 0 1.342-.314l2-1A2.986 2.986 0 0 0 17 12V9.033a2.985 2.985 0 0 0-1.658-2.683l-2-1a3.014 3.014 0 0 0-2.683 0l-2 1A2.985 2.985 0 0 0 7 9.033V12a2.986 2.986 0 0 0 1.658 2.684l2 1A3 3 0 0 0 12 16Zm-3-4V9.033a1 1 0 0 1 .051-.3l2.18 1.09a1.72 1.72 0 0 0 1.538 0l2.18-1.09a1 1 0 0 1 .051.3V12a.994.994 0 0 1-.553.895l-2 1a1.008 1.008 0 0 1-.895 0l-2-1A.994.994 0 0 1 9 12Zm10 10h-2.709l3.487-3.222a11 11 0 1 0-15.528.028L7.709 22H5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2ZM5.636 4.636a9 9 0 0 1 12.757 12.7l-3.985 3.68A3.514 3.514 0 0 1 9.571 21l-3.935-3.636a9.01 9.01 0 0 1 0-12.728Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLocationIcon;